import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\IncomePositionController::store
* @see app/Http/Controllers/Investors/IncomePositionController.php:16
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions'
*/
export const store = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/credit/{naturalPerson}/income-positions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::store
* @see app/Http/Controllers/Investors/IncomePositionController.php:16
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions'
*/
store.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return store.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::store
* @see app/Http/Controllers/Investors/IncomePositionController.php:16
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions'
*/
store.post = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::update
* @see app/Http/Controllers/Investors/IncomePositionController.php:40
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
export const update = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::update
* @see app/Http/Controllers/Investors/IncomePositionController.php:40
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
update.url = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            incomePosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        incomePosition: typeof args.incomePosition === 'object'
        ? args.incomePosition.id
        : args.incomePosition,
    }

    return update.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{incomePosition}', parsedArgs.incomePosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::update
* @see app/Http/Controllers/Investors/IncomePositionController.php:40
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
update.put = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::update
* @see app/Http/Controllers/Investors/IncomePositionController.php:40
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
update.patch = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::destroy
* @see app/Http/Controllers/Investors/IncomePositionController.php:52
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::destroy
* @see app/Http/Controllers/Investors/IncomePositionController.php:52
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            incomePosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        incomePosition: typeof args.incomePosition === 'object'
        ? args.incomePosition.id
        : args.incomePosition,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{incomePosition}', parsedArgs.incomePosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\IncomePositionController::destroy
* @see app/Http/Controllers/Investors/IncomePositionController.php:52
* @route '//app.finesthub.de/credit/{naturalPerson}/income-positions/{incomePosition}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } } | [naturalPerson: string | number | { id: string | number }, incomePosition: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const IncomePositionController = { store, update, destroy }

export default IncomePositionController